import { render } from "./delete-user-modal.vue?vue&type=template&id=61be3e40&scoped=true&lang=pug"
import script from "./delete-user-modal.vue?vue&type=script&lang=js"
export * from "./delete-user-modal.vue?vue&type=script&lang=js"

import "./delete-user-modal.vue?vue&type=style&index=0&id=61be3e40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61be3e40"]])

export default __exports__